import {
	Badge,
	Button,
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from "@dune/ui";
import { WEBHOOK_EVENT_DETAILS, type WebhookDeliveryDto } from "@dune/types";
import {
	WEBHOOK_STATUS_LABELS,
	formatJson,
	getStatusBadgeVariant,
} from "../utils";
import { formatDateTime } from "@dune/utils";

export interface WebhookDeliveryDetailsDialogProps {
	delivery: WebhookDeliveryDto | null;
	onClose: () => void;
}

export const WebhookDeliveryDetailsDialog = ({
	delivery,
	onClose,
}: WebhookDeliveryDetailsDialogProps) => (
	<Dialog open={!!delivery} onOpenChange={(next) => (!next ? onClose() : null)}>
		<DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto">
			<DialogHeader>
				<DialogTitle>Details de la diffusion</DialogTitle>
				<DialogDescription>
					Consultez le payload envoye et la reponse du destinataire.
				</DialogDescription>
			</DialogHeader>
			{delivery && (
				<div className="space-y-6">
					<div className="grid gap-4 md:grid-cols-2">
						<div>
							<p className="text-sm text-muted-foreground">Webhook</p>
							<p className="font-medium">
								{delivery.webhook?.name ?? `Webhook #${delivery.webhookId}`}
							</p>
							{delivery.webhook?.url && (
								<a
									href={delivery.webhook.url}
									target="_blank"
									rel="noreferrer"
									className="text-xs text-primary underline break-all"
								>
									{delivery.webhook.url}
								</a>
							)}
						</div>
						<div>
							<p className="text-sm text-muted-foreground">Évènement</p>
							<p className="font-medium">
								{WEBHOOK_EVENT_DETAILS[delivery.event]?.label ?? delivery.event}
							</p>
						</div>
						<div>
							<p className="text-sm text-muted-foreground">Statut</p>
							<Badge variant={getStatusBadgeVariant(delivery.status)}>
								{WEBHOOK_STATUS_LABELS[delivery.status] ?? delivery.status}
							</Badge>
						</div>
						<div>
							<p className="text-sm text-muted-foreground">Tentatives</p>
							<p className="font-medium">{delivery.attemptCount}</p>
						</div>
						<div>
							<p className="text-sm text-muted-foreground">Signature</p>
							<code className="text-xs break-all">
								{delivery.signature || "—"}
							</code>
						</div>
						<div>
							<p className="text-sm text-muted-foreground">Timestamp</p>
							<p className="font-medium">
								{delivery.timestamp ? formatDateTime(delivery.timestamp) : "—"}
							</p>
						</div>
					</div>

					<div>
						<p className="text-sm font-medium">Payload envoye</p>
						<div className="mt-2 rounded-md bg-muted p-3 text-sm">
							<pre className="whitespace-pre-wrap break-all">
								{formatJson(delivery.payload)}
							</pre>
						</div>
					</div>

					<div>
						<p className="text-sm font-medium">Reponse du destinataire</p>
						<div className="mt-2 rounded-md border p-3 text-sm whitespace-pre-wrap break-all">
							{delivery.responseBody ?? delivery.responseError ?? "—"}
						</div>
						{delivery.responseStatusCode && (
							<p className="mt-1 text-xs text-muted-foreground">
								HTTP {delivery.responseStatusCode}
							</p>
						)}
					</div>
				</div>
			)}
			<DialogFooter>
				<Button onClick={onClose}>Fermer</Button>
			</DialogFooter>
		</DialogContent>
	</Dialog>
);
